<template>
    <layout title="Completa tu pedido">
        <div class="content-area width-normal">
            <main id="main" class="site-main">
                <div class="cont maincont">
                    <h1 class="maincont-ttl">Completar el pedido</h1>
                    <ul class="b-crumbs">
                        <li><a href="index.html">Inicio</a></li>
                        <li>Completar el pedido</li>
                    </ul>
                    <div class="page-styling">

                        <div class="bg-white px-8 py-6">
                            <h2>Vamos a completar tu pedido</h2>
                            <p class="px-3 py-2 leading-relaxed border-0 border-solid border-l-4 border-green-600 bg-green-200 text-gray-900" style="line-height: 1.30 !important;">
                                <span class="font-bold">Recuerda</span><br>Una vez que llenes y envíes este formulario, nos pondremos en contacto contigo para coordinar la entrega de tu pedido, precio de envío y cualquier otro detalle que desees especificar. Por favor proporciona información exacta para que podamos atenderte de la mejor manera.
                            </p>
                            <div class="flex gap-x-4 mb-4">
                                <div class="w-1/2">
                                    <label for="name" class=" mb-1 text-base block font-bold">Nombres y apellidos</label>
                                    <input v-model="clientInfo.name" type="text" id="name" placeholder="Escribe tus nombres y apellidos">
                                    <div class="text-red-500 text-sm" v-if="$page.errors.name">{{ $page.errors.name[0] }}</div>
                                </div>
                                <div class="w-1/2">
                                    <label for="phone" class=" mb-1 text-base block font-bold">Número de teléfono</label>
                                    <input v-model="clientInfo.phone" type="text" id="phone" placeholder="Escribe número de teléfono">
                                    <div class="text-red-500 text-sm" v-if="$page.errors.phone">{{ $page.errors.phone[0] }}</div>
                                </div>
                            </div>
                            <div class="flex gap-x-4 mb-4">
                                <div class="w-1/2">
                                    <label for="pay_method" class=" mb-1 text-base block font-bold">Forma de pago</label>
                                    <t-select v-model="clientInfo.pay_method" class="w-full">
                                        <option v-for="method in pay_methods" :key="method" :value="method">{{ method | upperCase }}</option>
                                    </t-select>
                                    <div class="text-red-500 text-sm" v-if="$page.errors.pay_method">{{ $page.errors.pay_method[0] }}</div>
                                </div>
                            </div>
                            <div class="flex gap-x-4 mb-4">
                                <div class="w-full">
                                    <label for="address" class=" mb-1 text-base block font-bold">Dirección de entrega</label>
                                    <input v-model="clientInfo.address" type="text" id="address" placeholder="Escribe la dirección donde deseas que entreguemos tu pedido">
                                    <div class="text-red-500 text-sm" v-if="$page.errors.address">{{ $page.errors.address[0] }}</div>
                                </div>
                            </div>
                            <div class="flex gap-x-4 mb-4">
                                <div class="w-full">
                                    <label for="comments" class=" mb-1 text-base block font-bold">Observaciones (opcional)</label>
                                    <textarea v-model="clientInfo.comments" class="resize-none" id="comments" style="padding-top: 0.75rem !important; padding-bottom: 0.75rem !important;" placeholder="Escribe aquí alguna observación o instrucción para tu pedido"></textarea>
                                    <div class="text-red-500 text-sm" v-if="$page.errors.comments">{{ $page.errors.comments[0] }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <h2>Resumen del pedido</h2>
                            <div class="woocommerce prod-litems section-list">
                                <!-- <div
                                    v-for="item in $page.cart.details"
                                    :key="item.rowId"
                                    class="flex"
                                >
                                    <div><img :src="item.options.image" class="w-full"></div>
                                    <div>
                                        <div v-if="item.options.category">{{ item.options.category.name }}</div>
                                        <div>{{ item.name }}</div>
                                    </div>
                                    <div></div>
                                </div> -->
                                <cart-item
                                    v-for="item in $page.cart.details"
                                    :key="item.rowId"
                                    :item="item"
                                    :show-controls="false"
                                ></cart-item>
                            </div>

                            <div class="flex flex-col items-center gap-y-2 md:flex-row md:justify-between px-6 py-4 bg-white">
                                <div v-if="$page.config.taxes.iva.show" class="flex flex-col justify-center w-1/4 text-base">
                                    <div class="text-center">
                                        <div class="font-bold">IVA:</div>
                                        <div v-if="$page.cart">${{ $page.cart.tax }}</div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <div class="font-bold">Subtotal</div>
                                    <div v-if="$page.cart" class="text-gray-600 text-lg">${{ $page.cart.subtotal }}</div>
                                </div>
                                <div class="text-center">
                                    <div class="font-bold">Total</div>
                                    <div v-if="$page.cart" class="text-green-500 text-xl">${{ $page.cart.total }}</div>
                                </div>
                                <!-- <p>
                                    <div class="g-recaptcha" data-sitekey="6LfqacYZAAAAANlpHNEq2ekPXL5his2laiZ97VnE"></div>
                                </p> -->
                                <div class="flex justify-center">
                                    <button v-if="Object.keys($page.cart.details).length" @click="checkout" class="btn btn-primary rounded-sm" :disabled="checkingOut">
                                        <span v-if="!checkingOut">ENVIAR PEDIDO</span>
                                        <span v-if="checkingOut"><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </layout>
</template>

<script>
import Layout from '../Layout';
import TSelect from '../../components/TSelect';
import CartItem from '../../components/Cart/CartItem';

export default {
    components: {
        Layout,
        TSelect,
        CartItem,
    },
    data() {
        return {
            pay_methods: [
                'efectivo',
            ],

            clientInfo: {
                name: '',
                phone: '',
                pay_method: 'efectivo',
                address: '',
                comments: '',
                'g-recaptcha-response': '',
            },

            checkingOut: false,
        };
    },

    mounted() {
        if (this.$page.flash['order-completed']) {
            Swal.fire({
                title: '¡Gracias por tu compra!',
                text: 'Hemos recibido tu pedido. Dentro de unos minutos nos comunicarémos contigo para coordinar la entrega de tu pedido, precio de envío y cualquier otro detalle que desees especificar. Mientras tanto puedes seguir viendo nuestros productos.',
                icon: 'success',
                confirmButtonText: '¡Genial!'
            }).then((result) => {
                this.$inertia.visit('/productos');
            });
        }
        this.hydrateOldClientInfo();

        // document.getElementById('grecaptcha').remove()
        // var grecaptcha = document.createElement('script');
        // grecaptcha.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
        // grecaptcha.setAttribute('id', 'grecaptcha');
        // document.head.appendChild(grecaptcha);


    },

    methods: {
        checkout() {
            this.checkingOut = true;
            // this.clientInfo['g-recaptcha-response'] = document.getElementById('g-recaptcha-response').value;

            this.$inertia.post('/checkout', this.clientInfo, {
                preserveState: false,
            });
        },

        hydrateOldClientInfo() {
            var keys = Object.keys(this.clientInfo);

            keys.forEach(key => {
                if (this.$page.old[key]) {
                    this.clientInfo[key] = this.$page.old[key];
                }
            });
        },
    },

    filters: {
        upperCase(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
    }
}
</script>

<style>

</style>
